// Shop-Einlösungen (streamshop / shop.abgemiked.de) — hartes Isolationsprinzip:
// eigener Typ + Guard, kennt Twitch/Ko-fi/YouTube nicht (analog kofi.ts).

export interface ShopRedemptionEvent {
  type: 'shop_redemption';
  source: 'shop';
  /** Anzeigename des einlösenden Viewers. */
  user: string;
  /** Name des eingelösten Shop-Items. */
  itemName: string;
  /** Kosten in Scheibenwischer-Punkten. */
  cost: number;
  /** true = Raffle-Anmeldung (Slot belegt) statt sofortiger Einlösung. */
  isRaffle: boolean;
  receivedAt: number;
}

export function isShopEvent(value: unknown): value is ShopRedemptionEvent {
  if (!value || typeof value !== 'object') return false;
  const v = value as { type?: string; source?: string };
  return v.source === 'shop' && v.type === 'shop_redemption';
}
